import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";

import en from "./en";
import th from "./th";

Vue.use(VueI18n);

const defaultLanguage = "th"; 

const i18n = new VueI18n({
  locale: defaultLanguage, 
  silentTranslationWarn: true,
  fallbackLocale: 'en',
  messages: { en, th },
});
if (store) {
  store.watch(
    (state) => state.settingModules?.language, 
    (newLanguage) => {
      if (newLanguage) {
        i18n.locale = newLanguage;
      }
    }
  );
}

export default i18n;
export const t = i18n.t.bind(i18n);
